import { userInfoEndpoint } from "@healthos/shared";
import { useQuery } from "@tanstack/react-query";
import { fetchMemberName } from "../member-name.js";
import { queryKeys } from "../query-keys.js";
export function useMemberName(args) {
    const { token, userId, issuer, clientFactory } = args;
    return useQuery({
        queryKey: queryKeys.memberName(userId ?? ""),
        queryFn: () => {
            if (!token || !userId || !issuer)
                throw new Error("unauthenticated");
            return fetchMemberName({
                userId,
                accessToken: token,
                userInfoUrl: userInfoEndpoint(issuer),
                client: () => clientFactory(token),
            });
        },
        enabled: Boolean(token && userId && issuer),
        staleTime: 30 * 60_000,
    }).data;
}
//# sourceMappingURL=use-member-name.js.map